// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  const yarnPage = document.getElementById('yarn-page')
  if (yarnPage) {
    const productForm = document.getElementById('productForm')
    if (productForm) {
      const swatches = productForm.querySelectorAll('.colors-wrapper .swatch-circle')

      const variant = urlParams.get('variant')

      if (swatches && variant) {
        for (const swatch of swatches) {
          if (swatch.getAttribute('data-variant') === variant) {
            swatch.click()
          }
        }
      }
    }
  }
})
